export default __webpack_public_path__ + "static/media/theatre.205dc767.svg";